<template>
  <div>
    <v-img v-if="hasCustomDomain || hasCustomisation" :height="height" :width="width" contain :position="position"
           :style="'background-color:'+ (transparent?'none': userDetails.Office.Colors.BrandBackgroundColor)+';'"
           :src="imagepath"></v-img>
    <v-card-title class="text-center" v-if="!(hasCustomisation || hasCustomDomain)">
      {{ userDetails.Office.BrandName }}
    </v-card-title>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "DomainImage",
  computed: {

    imagepath() {
      console.log('this.hasCustomisation', this.hasCustomisation)
      if (this.hasCustomisation && (this.subdomain === 'managers' || this.subdomain === 'localhost')) {
        return 'https://managers.winlift.gr/subdomains/' + this.userDetails.Office.ID + '.png'
      } else {
        return 'https://managers.winlift.gr/subdomains/' + this.subdomain + '.png'
      }
    },

    hasCustomDomain() {
      return this.subdomain !== 'managers' && this.subdomain !== 'localhost'
    },
    hasCustomisation() {
      return this.userDetails.Office.Colors.AppbarColor !== 'primary' && this.userDetails.Office.Colors.AppbarColor !== '#444BA2'
    },

    ...mapGetters([
      'userDetails',

    ]),
    ...mapState([
      'subdomain'
    ]),
  },
  props: {
    position: {type: String, default: 'left center', required: false},
    transparent: {type: Boolean, default: false, required: false},
    hideBrandName: {type: Boolean, default: false, required: false},
    height: {type: String, default: null, required: false},
    width: {type: String, default: null, required: false}
  }
}
</script>

<style scoped>

</style>
